import React from 'react';

export default () => (
  <svg 
    width="21" 
    height="21" 
    viewBox="0 0 21 21" 
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 12.1765V20H21V18.8255C21 18.5096 20.8508 18.2123 20.5975 18.0236L11.2947 11.0921C10.8547 10.7643 10.2326 10.8523 9.90075 11.2894L6.44076 15.8469C6.10574 16.2882 5.47576 16.373 5.03599 16.036L0 12.1765ZM0 5.47059L3.86877 8.25025C4.3117 8.56849 4.92794 8.47312 5.25395 8.03588L9.8943 1.81235C10.2275 1.36545 10.8618 1.27729 11.3043 1.61639L15.2567 4.64544C15.9549 5.18057 16.8101 5.47059 17.6898 5.47059H21V15.4959L10.8286 7.91831C10.3883 7.59032 9.76593 7.6786 9.43425 8.11609L5.99762 12.6491C5.66261 13.091 5.03199 13.1759 4.59203 12.8384L0.391294 9.6155C0.144616 9.42624 0 9.13302 0 8.8221V5.47059Z" fill="currentColor" />
  </svg>
);
